import { useGetSectionDefinitionsQuery } from 'API/order/fees/FeeApi';
import { ILineItemProps } from './ILineItemProps';
import { useMemo } from 'react';

export const useGetCurrentSectionDefinition = ({ sectionDefinitionId }: ILineItemProps) => {
  const { data } = useGetSectionDefinitionsQuery();
  return useMemo(
    () => data?.find((t) => t.statementSectionDefinitionId === sectionDefinitionId),
    [data, sectionDefinitionId]
  );
};
